import React, { useState, useEffect } from "react";
import instance from "../../instance";

import "../Customer.css";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const CustomerInformation = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const code = params.get("code");
  const [startDate, setStartDate] = useState(new Date());

  const [informationData, setInformationData] = useState(null);
  const [isEditingInformation, setIsEditingInformation] = useState(false);
  const [showWifiPassword, setShowWifiPassword] = useState(false);
  const [informationFormData, setInformationFormData] = useState({
    StartDate: new Date(),
    Name: "",
    NameOwner: "",
    Phone: "",
    City: "",
    Governorate: "",
    WifiName: "",
    WifiPassword: "",
    Latitude: "",
    Longitude: "",
  });

  useEffect(() => {
    if (code) {
      fetchInformationData();
    } else {
      toast.error("No code provided.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- fetchInformationData is recreated each render; adding it would refetch on every paint
  }, [code]);

  const fetchInformationData = async () => {
    try {
      const response = await instance.get(`information/by-code/${code}`);
      if (response.status !== 200) {
        throw new Error("Failed to fetch information data.");
      }
      const data = response.data;
      if (data && data.data) {
        setInformationData(data.data);
        setInformationFormData({
          StartDate: new Date(data.data.StartDate),
          Name: data.data.Name,
          NameOwner: data.data.NameOwner,
          Phone: data.data.Phone,
          City: data.data.City,
          Governorate: data.data.Governorate,
          WifiName: data.data.WifiName,
          WifiPassword: data.data.WifiPassword,
          Latitude: data.data.Latitude || "",
          Longitude: data.data.Longitude || "",
        });
        setStartDate(new Date(data.data.StartDate));
      } else {
        toast.error("No customer information data found for the given code.");
      }
    } catch (error) {
      console.error("Error fetching customer information data:", error);
      toast.error(
        "An error occurred while fetching customer information data."
      );
    }
  };

  const handleStartDateChange = (date) => {
    setStartDate(date);
    setInformationFormData({ ...informationFormData, StartDate: date });
  };

  const formatDate = (date) => {
    const d = new Date(date);
    return d.toLocaleDateString("en-GB");
  };

  const calculateDaysSinceStart = (start) => {
    const now = new Date();
    const diffTime = Math.abs(now - new Date(start));
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  const toggleEditInformation = () => {
    if (isEditingInformation) {
      saveInformationData();
    } else {
      setIsEditingInformation(!isEditingInformation);
    }
  };

  const handleInformationInputChange = (event) => {
    const { id, value } = event.target;
    setInformationFormData({ ...informationFormData, [id]: value });
  };

  const saveInformationData = async () => {
    const code = informationData.Code;
    try {
      const response = await instance.put(
        `information/by-code/${code}`,
        {
          ...informationFormData,
          StartDate: startDate.toISOString().split("T")[0],
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      toast.success("Customer Information updated successfully!");
      fetchInformationData(); // Fetch updated data instead of reloading the page
      setIsEditingInformation(false); // Exit editing mode
    } catch (error) {
      console.error("Error updating customer Information data:", error);
      toast.error(
        "An error occurred while updating customer Information data."
      );
    }
  };

  const toggleWifiPasswordVisibility = () => {
    setShowWifiPassword(!showWifiPassword);
  };

  const isStartDateOverdue = (startDate) => {
    return new Date(startDate) > new Date();
  };

  return (
    <div>
      <main>
        <section id="info-section">
          <h2>Information</h2>
          {informationData && (
            <ul>
              <li>
                Date:{" "}
                <span className="info2" id="info-date">
                  {formatDate(informationData.Date)}
                </span>
              </li>
              <li>
                Code:{" "}
                <span className="info3" id="info-code">
                  {informationData.Code}
                </span>
              </li>
              <li>
                Start Date:{" "}
                <span
                  className={`info3 ${isEditingInformation ? "hidden" : ""}`}
                  id="info-startDate"
                  style={{
                    fontSize: "16px",
                    backgroundColor:
                      informationData.StartDate &&
                      new Date(informationData.StartDate) >= new Date()
                        ? "rgba(255, 0, 0, 0.2)"
                        : "transparent",
                  }}
                >
                  {formatDate(informationData.StartDate)}
                </span>
                {isEditingInformation && (
                  <DatePicker
                    selected={startDate}
                    onChange={handleStartDateChange}
                    dateFormat="dd/MM/yyyy"
                    className="input-field"
                    id="StartDate"
                  />
                )}
              </li>
              <li>
                Start Days:{" "}
                <span
                  className="info3"
                  id="days-since-start"
                  style={{
                    fontSize: "16px",
                    backgroundColor: isStartDateOverdue(
                      informationData.StartDate
                    )
                      ? "rgba(255, 0, 0, 0.2)"
                      : "white",
                  }}
                >
                  {calculateDaysSinceStart(informationData.StartDate)}
                </span>
              </li>
              <li>
                Name:{" "}
                <span
                  className={`info2 ${isEditingInformation ? "hidden" : ""}`}
                  id="info-name"
                  style={{
                    fontSize: "16px",
                  }}
                >
                  {informationData.Name}
                </span>
                {isEditingInformation && (
                  <input
                    className="input-field"
                    type="text"
                    id="Name"
                    value={informationFormData.Name}
                    onChange={handleInformationInputChange}
                  />
                )}
              </li>
              <li>
                Name Owner:{" "}
                <span
                  className={`info2 ${isEditingInformation ? "hidden" : ""}`}
                  id="info-nameOwner"
                >
                  {informationData.NameOwner}
                </span>
                {isEditingInformation && (
                  <input
                    className="input-field"
                    type="text"
                    id="NameOwner"
                    value={informationFormData.NameOwner}
                    onChange={handleInformationInputChange}
                  />
                )}
              </li>
              <li>
                Phone:{" "}
                <span
                  className={`info2 ${isEditingInformation ? "hidden" : ""}`}
                  id="info-phone"
                >
                  {informationData.Phone}
                </span>
                {isEditingInformation && (
                  <input
                    className="input-field"
                    type="text"
                    id="Phone"
                    value={informationFormData.Phone}
                    onChange={handleInformationInputChange}
                  />
                )}
              </li>
              <li>
                City:{" "}
                <span
                  className={`info2 ${isEditingInformation ? "hidden" : ""}`}
                  id="info-city"
                >
                  {informationData.City}
                </span>
                {isEditingInformation && (
                  <input
                    className="input-field"
                    type="text"
                    id="City"
                    value={informationFormData.City}
                    onChange={handleInformationInputChange}
                  />
                )}
              </li>
              <li>
                Governorate:{" "}
                <span
                  className={`info2 ${isEditingInformation ? "hidden" : ""}`}
                  id="info-governorate"
                >
                  {informationData.Governorate}
                </span>
                {isEditingInformation && (
                  <input
                    className="input-field"
                    type="text"
                    id="Governorate"
                    value={informationFormData.Governorate}
                    onChange={handleInformationInputChange}
                  />
                )}
              </li>
              <li>
                Wifi Name:{" "}
                <span
                  className={`info2 ${isEditingInformation ? "hidden" : ""}`}
                  id="info-wifiName"
                >
                  {informationData.WifiName}
                </span>
                {isEditingInformation && (
                  <input
                    className="input-field"
                    type="text"
                    id="WifiName"
                    value={informationFormData.WifiName}
                    onChange={handleInformationInputChange}
                  />
                )}
              </li>
              <li>
                Wifi Password:{" "}
                <span
                  className={`info3 ${isEditingInformation ? "hidden" : ""}`}
                  id="info-wifi-password"
                >
                  {showWifiPassword ? informationData.WifiPassword : "••••••••"}
                </span>
                {isEditingInformation && (
                  <input
                    className="input-field"
                    type={showWifiPassword ? "text" : "password"}
                    id="WifiPassword"
                    value={informationFormData.WifiPassword}
                    onChange={handleInformationInputChange}
                  />
                )}
                <button className="show" onClick={toggleWifiPasswordVisibility}>
                  {showWifiPassword ? "Hide" : "Show"}
                </button>
              </li>
              <li>
                Latitude:{" "}
                <span
                  className={`info2 ${isEditingInformation ? "hidden" : ""}`}
                  id="info-latitude"
                >
                  {informationData.Latitude || "N/A"}
                </span>
                {isEditingInformation && (
                  <input
                    className="input-field"
                    type="number"
                    step="any"
                    id="Latitude"
                    value={informationFormData.Latitude}
                    onChange={handleInformationInputChange}
                    placeholder="Enter Latitude"
                  />
                )}
              </li>
              <li>
                Longitude:{" "}
                <span
                  className={`info2 ${isEditingInformation ? "hidden" : ""}`}
                  id="info-longitude"
                >
                  {informationData.Longitude || "N/A"}
                </span>
                {isEditingInformation && (
                  <input
                    className="input-field"
                    type="number"
                    step="any"
                    id="Longitude"
                    value={informationFormData.Longitude}
                    onChange={handleInformationInputChange}
                    placeholder="Enter Longitude"
                  />
                )}
              </li>
              <button className="edit-button" onClick={toggleEditInformation}>
                {isEditingInformation ? "Save" : "Update"}
              </button>
            </ul>
          )}
        </section>
      </main>
    </div>
  );
};

export default CustomerInformation;
